__turbopack_context__.v({
  "className": "foundersgroteskregular_57bbb87b-module__O0qyHq__className",
});
